import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { CommonStyledComponentProps } from '__utils/type';

export const Button = styled.button`
    display: inline-block;
    margin-bottom: 0;
    font-size: 14px;
    height: 40px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 4px;
    width: 100%;
`;

export const SuccessButton = styled(Button)<any>`
    color: #fff;
    background-color: ${COLOR.GREEN};
    border: ${COLOR.GREEN};
    width: ${props => (props?.width ? `${props.width}` : '')};
    &:hover,
    &:focus,
    &:active {
        background-color: ${COLOR.GREEN};
        border-color: ${COLOR.GREEN};
        color: #ffffff;
    }
    &:disabled {
        background: ${COLOR.LIGHTGREY} !important;
        cursor: default;
        color: #9e9e9e;;
    }
`;

export const SuccessButtonWhiteBg = styled(Button)`
    color: ${COLOR.GREEN};
    background-color: transparent;
    border: transparent;
    &:hover,
    &:focus,
    &:active {
        background-color: transparent;
        border-color: ${COLOR.GREEN};
        color: ${COLOR.GREEN};
    }
    &:disabled {
        background: ${COLOR.LIGHTGREY} !important;
        cursor: default;
        color: #fff;
        border-color: transparent;

    }
`;

export const SuccessBtnWhiteGreenBorder = styled(SuccessButtonWhiteBg)<any>`
    width: ${props => props?.width ? props?.width : 'auto'};
    padding: 0 20px;
    font-size: 14px; 
    border: 1px solid ${COLOR.GREEN};
    &:disabled {
        background: ${COLOR.DISABLED_BTN} !important;
    }
    &:disabled:hover {
        background: ${COLOR.DISABLED_BTN} !important;
        cursor: default;
        color: #fff;
    }
`;

export const PrimarySmallBtn = styled(Button)`
    background-color: #00A465;
    border: #00A465 solid 1px;
    color: #ffffff;
    padding: 6px 14px;
    font-size: 14px;
    font-weight: 500;
    text-transform: capitalize;
    line-height: unset;
    height: unset;
    width: unset;
`;
export const GreenButtonSmall = styled(Button)<any>`
    color: #fff;
    width: ${props => props?.width ? props?.width : 'auto'};
    padding: 5px 20px;
    height: unset;
    font-size: 14px; 
    border: 1px solid ${COLOR.GREEN};
    background-color: ${COLOR.GREEN};
    border: ${COLOR.GREEN};
    &:hover,
    &:focus,
    &:active {
        background-color: ${COLOR.GREEN};
        border-color: ${COLOR.GREEN};
        color: #ffffff;
    }
    &:disabled {
        background: ${COLOR.LIGHTGREY} !important;
        cursor: default;
        color: #9e9e9e;;
    }
`;

export const RoundedButton = styled(Button)<any>`
    color: #000;
    background-color: ${COLOR.WHITE};
    border-radius: 100px;
    &:hover,
    &:focus,
    &:active {
        background-color: ${COLOR.GREEN};
        border-color: ${COLOR.GREEN};
        color: #ffffff;
    }
    &:disabled {
        background: ${COLOR.LIGHTGREY} !important;
        cursor: default;
        color: #9e9e9e;;
    }
`;
export const PillButton = styled(RoundedButton)<any>`
    color: #000;
    height: 36px;
    background: linear-gradient(141.34deg, #F0F9FF -4.26%, #FAFFFB 107.05%);
    border: 1.5px solid ${COLOR.WHITE};
    box-shadow: 0px 2px 12px rgba(167, 227, 162, 0.48);
    font-weight: 400;
    &:hover,
    &:focus,
    &:active,
    &.active
    {
        background: linear-gradient(141.34deg, #F0F9FF -4.26%, #FAFFFB 107.05%);
        border: 1.5px solid ${COLOR.GREEN};
        color: #000;
    }
    &:disabled {
        background: ${COLOR.LIGHTGREY} !important;
        cursor: default;
        color: #9e9e9e;;
    }
`; 

export const BlackBgRoundButton = styled(RoundedButton) <CommonStyledComponentProps>`
    color: ${COLOR.WHITE};
    background-color: ${COLOR.BLACK};
    &:hover,
    &:focus,
    &:active {
        background-color: ${COLOR.BLACK};
        border: none;
        color: ${COLOR.WHITE};
    }
    &:disabled {
        background: ${COLOR.GREY3} !important;
        cursor: default;
        color: #fff;
    }
`
export const SuccessButtonLAMF = styled(Button)<any>`
    display: flex;
    padding: var(--spacing-sp-8, 8px) var(--spacing-sp-48, 48px);
    justify-content: center;
    align-items: center;
    height: 32px;
    border-radius: 8px;
    border: 1px solid var(--color-netural-600, #191C1B);
    background: var(--color-netural-000, #FFF);
    font-size: 12px;
`;